export const siteConfig = {
  name: "Harper",
  description: "Harper - AI-powered medical assistant",
  url: "https://app.harper.new",
  iosAppStoreUrl: "https://apple.co/3HK3sOa",
  androidPlayStoreUrl:
    "https://play.google.com/store/apps/details?id=com.harperapp.mobile",
};
